module.exports = __webpack_public_path__ + "static/img/request.d7b50738.svg";